import React from "react";
import { caseTypeCommonFields } from "./CaseFormFields";

const MultiStepProgressBar = ({ page }) => {
  const count = caseTypeCommonFields.length;
  var stepPercentage = ((parseInt(page) + 1) / parseInt(count)) * 100;

  return (
    <div className="w-full mb-10 font-plexsans">
      <div className="text-[12.5px] font-semibold text-[rgba(20,33,61,.55)] mb-2">
        Step {parseInt(page) + 1} of {parseInt(count)}
      </div>
      <div className="w-full h-1.5 rounded-full bg-[rgba(20,33,61,.08)] overflow-hidden">
        <div
          className="h-full rounded-full bg-tan transition-[width] duration-300"
          style={{ width: `${stepPercentage}%` }}
        />
      </div>
    </div>
  );
};

export default MultiStepProgressBar;
